import { render, staticRenderFns } from "./_RestaurantUsersManagement.vue?vue&type=template&id=b89905b0&scoped=true"
import script from "./_RestaurantUsersManagement.vue?vue&type=script&lang=ts"
export * from "./_RestaurantUsersManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89905b0",
  null
  
)

export default component.exports